'use client';

const FONT: React.CSSProperties = {
  fontFamily: 'Outfit, sans-serif',
  fontSize: 'clamp(2.5rem, 10vw, 4rem)',
  fontWeight: 700,
  letterSpacing: '-0.02em',
  lineHeight: 1,
  userSelect: 'none',
};

// "Aksa" = white, "demia" = primary teal — sweep animates opacity across all 9 letters
const LETTERS: { char: string; color: string }[] = [
  { char: 'A', color: '#ffffff' },
  { char: 'k', color: '#ffffff' },
  { char: 's', color: '#ffffff' },
  { char: 'a', color: '#ffffff' },
  { char: 'd', color: '#134e4a' },
  { char: 'e', color: '#134e4a' },
  { char: 'm', color: '#134e4a' },
  { char: 'i', color: '#134e4a' },
  { char: 'a', color: '#134e4a' },
];

export function LoadingScreen() {
  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center"
      style={{ backgroundColor: '#0d9488' }}
    >
      <div style={{ display: 'flex', alignItems: 'baseline' }}>
        {LETTERS.map(({ char, color }, i) => (
          <span
            key={i}
            style={{
              ...FONT,
              color,
              animation: 'letterSweep 2.2s ease-in-out infinite',
              animationDelay: `${i * 0.1}s`,
            }}
          >
            {char}
          </span>
        ))}
      </div>

      {/* Progress bar — pinned to bottom */}
      <div className="fixed bottom-0 left-0 right-0 h-[3px]" style={{ backgroundColor: 'rgba(255,255,255,0.12)' }}>
        <div style={{ height: '100%', backgroundColor: 'rgba(255,255,255,0.5)', animation: 'progressBar 2.2s ease-in-out infinite' }} />
      </div>

      <style>{`
        @keyframes letterSweep {
          0%, 15%  { opacity: 0.18; }
          45%, 60% { opacity: 1; }
          90%, 100% { opacity: 0.18; }
        }
        @keyframes progressBar {
          0%   { width: 0%; }
          80%  { width: 100%; }
          100% { width: 100%; opacity: 0; }
        }
      `}</style>
    </div>
  );
}
